import { render } from "./ProfessionalNotesPage.vue?vue&type=template&id=048ed8cc&scoped=true"
import script from "./ProfessionalNotesPage.vue?vue&type=script&lang=js"
export * from "./ProfessionalNotesPage.vue?vue&type=script&lang=js"

import "./ProfessionalNotesPage.vue?vue&type=style&index=0&id=048ed8cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048ed8cc"]])

export default __exports__